var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuntosInteres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Beneficios",
    xmlns: "http://www.w3.org/2000/svg",
    width: 235.781,
    height: 344.952,
    viewBox: "0 0 235.781 344.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #418c5a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-1",
    d: "M186.964,268.662a163.076,163.076,0,0,0-26.906-6.851c6.292-7.389,13-15.585,19.731-24.34,37.158-48.293,55.993-88.535,55.993-119.574A117.891,117.891,0,1,0,0,117.891C0,149.109,18.841,189.4,55.993,237.63c6.706,8.707,13.377,16.847,19.648,24.195a163.1,163.1,0,0,0-26.823,6.837C20.787,278.679,14.9,292.119,14.9,301.653s5.885,22.974,33.916,32.984c18.627,6.651,43.14,10.314,69.073,10.314s50.446-3.663,69.073-10.314c28.031-10.01,33.916-23.457,33.916-32.984S215,278.679,186.964,268.662ZM20.214,117.891a97.68,97.68,0,0,1,195.36,0c0,26.071-17.862,63.092-51.653,107.066a659.16,659.16,0,0,1-46.044,53.35A653.809,653.809,0,0,1,72.005,225.3C38.124,181.313,20.214,144.19,20.214,117.891ZM180.175,315.6c-16.482,5.892-38.635,9.134-62.284,9.134s-45.8-3.243-62.278-9.134c-14.909-5.333-20.5-11.356-20.5-13.95s5.588-8.617,20.5-13.964c10.19-3.636,22.532-6.257,36.068-7.734,10.976,11.984,18.572,19.414,19.159,20.007l7.071,6.9,7.051-6.9c.586-.573,8.148-8,19.09-20.007,13.557,1.476,25.92,4.1,36.123,7.741,14.929,5.34,20.5,11.39,20.5,13.957S195.1,310.27,180.175,315.6Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-1",
    d: "M218.7,131.511a8.094,8.094,0,0,0-15.379,4.962,50.185,50.185,0,1,1-34.239-32.912,8.1,8.1,0,1,0,4.347-15.6,66.374,66.374,0,1,0,45.329,43.548Z",
    transform: "translate(-37.503 -31.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-1",
    d: "M225,109.13l-.073-.073A8.095,8.095,0,0,0,213.513,120.5l.073.073a8.094,8.094,0,1,0,11.446-11.446Z",
    transform: "translate(-67.116 -33.706)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuntosInteres);
export default __webpack_public_path__ + "static/media/PuntosInteres.643b252a709b47a769d7902b9943823c.svg";
export { ForwardRef as ReactComponent };